import { Box, CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { Button } from 'components/buttons'
import { Icon } from 'components/icon'
import { Input } from 'components/input'
import ExportDataMyPeopleModal from 'components/modal/myPeople/ExportDataMypeopleModal'
import ExportDataSuccesModal from 'components/modal/myPeople/ExportDataSuccesModal'
import { Slide } from 'components/slide'
import ReachTable from 'components/table/reach/reachTable'
import { Typography } from 'components/typography'
import {
	Icons,
	ReachModalProps,
	ReachTableProps,
	TypographyTypes
} from 'interfaces'
import React, { useState } from 'react'
import { configGenaral } from 'utils'
import { TagReachModal } from './tagReachModal'

const ReachModal: React.FC<ReachModalProps> = ({
	resetInput,
	handleChangeDebounce,
	data,
	page,
	setPage,
	isLoadingReachDetail,
	isLoadingReachTable,
	titlesReach,
	dataReachDetail,
	onShowingItems,
	onShowingItemsChange,
	setOpenExport,
	openExport,
	setOpenExportSucces,
	openExportSucces,
	mutateExport,
	setSearch,
	search,
	reachModalTitle,
	setOpen,
	exportErrorMessage
}) => {
	const [slideOpen, setSlideOpen] = useState(false)

	const reachInfo = [
		{
			icon: Icons.myPeople,
			title: 'Total users',
			titleSecond: 'Reached',
			number: dataReachDetail?.total_users_reached ?? 0,
			type: 'total'
		},
		{
			icon: Icons.personPortrait,
			title: 'Percentage of',
			titleSecond: 'All users',
			number: dataReachDetail?.percentage_of_all_users ?? 0,
			type: 'percentage'
		}
		// TODO: add this later, if client request
		// {
		// 	icon: Icons.cardTag,
		// 	title: 'User',
		// 	titleSecond: 'Tags',
		// 	number: dataReachDetail?.user_tags ?? 0,
		// 	type: 'plus'
		// }
	]

	const formatNumber = (info: {
		number: number
		type: string
	}): JSX.Element | string => {
		switch (info.type) {
			case 'total':
				return info.number.toString()
			case 'percentage':
				return (
					<Box position="relative" display="inline-flex">
						<CircularProgress
							style={{}}
							variant="determinate"
							value={100}
							size={60}
							thickness={4}
							sx={{
								position: 'absolute',
								'& .MuiCircularProgress-circle': {
									strokeLinecap: 'round',
									stroke: '#c2c2c2 !important'
								}
							}}
							color="primary"
						/>
						<CircularProgress
							variant="determinate"
							value={info.number}
							size={60}
							thickness={4}
							sx={{
								'& .MuiCircularProgress-circle': {
									strokeLinecap: 'round',
									stroke: '#FFFFFF !important'
								}
							}}
							color="primary"
						/>
						<Box
							top={0}
							left={0}
							bottom={0}
							right={0}
							position="absolute"
							display="flex"
							alignItems="center"
							justifyContent="center"
						>
							<Typography
								title={`${info.number}%`}
								type={TypographyTypes.h3}
								fontLeading="12/15"
								className="text-white font-medium"
							/>
						</Box>
					</Box>
				)
			case 'plus':
				return `${info.number}`
			default:
				return info.number.toString()
		}
	}

	const handleClose = (): void => {
		setOpen(false)
		setSearch('')
		resetInput()
	}

	return (
		<div className="w-full flex flex-col items-center justify-center gap-4 py-4">
			<div className="w-full text-center border border-blue-primary rounded-full inline-block py-1">
				<Typography
					title={reachModalTitle}
					type={TypographyTypes.h3}
					fontLeading="18/21"
					className="text-[#5A5A5A] !font-normal"
				/>
				<Typography
					title={titlesReach}
					type={TypographyTypes.h3}
					fontLeading="18/21"
					className="text-[#5A5A5A]"
				/>
			</div>
			<div className="flex w-full gap-2">
				{isLoadingReachDetail
					? Array.from({ length: reachInfo.length }).map((_, index) => (
							<div
								key={index}
								className="bg-gray-3 animate-pulse rounded-xl w-[50%] h-20"
							/>
					  ))
					: reachInfo.map((item, index) => (
							<button
								className={clsx(
									'bg-blue-primary rounded-xl w-[50%] h-20 p-4',
									item.type === 'plus' ? 'cursor-pointer' : 'cursor-auto'
								)}
								key={index}
								onClick={
									item.type === 'plus' ? () => setSlideOpen(true) : undefined
								}
								type="button"
							>
								<div className="flex items-center justify-between gap-2 h-full">
									<div className="flex items-center justify-center gap-6">
										<Icon
											src={item.icon}
											className="text-white w-8 h-8"
											fillPath
										/>
										<div className="flex flex-col items-start gap-1">
											<Typography
												title={item.title}
												type={TypographyTypes.h3}
												fontLeading="12/15"
												className="text-white !font-normal text-base"
											/>
											<Typography
												title={item.titleSecond}
												type={TypographyTypes.h3}
												fontLeading="12/15"
												className="text-white font-semibold text-base"
											/>
										</div>
									</div>
									<Typography
										title={formatNumber(item) as string}
										type={TypographyTypes.h3}
										fontLeading="18/21"
										className="text-white text-4xl"
									/>
								</div>
							</button>
					  ))}
			</div>
			<div className="w-full flex items-center justify-center">
				<Input
					rightClick={() => {
						resetInput()
						setSearch('')
					}}
					name="search"
					cantLimit={configGenaral.maxSearchValue}
					search
					className="w-full"
					placeholder="Search Tags or Users"
					rightIcon={Icons.cancel}
					inputClassName="!p-[unset] !py-1 !px-2 !rounded-[16px]"
					inputFocus
					borderFull={false}
					onChangeCustom={e => {
						setSearch(e.target.value)
						handleChangeDebounce(e)
					}}
					value={search}
				/>
			</div>
			<Slide
				title="User Tags"
				titleHelper="If you set a Delivery Radius, this content item will be delivered when your audience enters the Radius."
				open={slideOpen}
				setOpen={setSlideOpen}
				classNameTitle="!text-black !font-bold"
				className="!max-w-[32.2rem] !max-h-[28.3rem]"
			>
				<TagReachModal data={dataReachDetail?.user_tags_detailed} />
			</Slide>
			{isLoadingReachTable ? (
				<div className="flex items-center justify-center w-full h-[calc(100vh_-_446px)] py-2 px-1 bg-white border-2 border-gray-7 rounded-lg">
					<CircularProgress />
				</div>
			) : (
				<>
					<ReachTable
						data={data as ReachTableProps}
						isLoading={isLoadingReachTable}
						page={page}
						setPage={setPage}
						onShowingItems={onShowingItems}
						onShowingItemsChange={onShowingItemsChange}
						className="overflow-auto"
					/>
					<div className="w-full flex items-center justify-end gap-4">
						<Button
							label="Cancel"
							className="!min-w-[10rem]"
							color="Transparent"
							onClick={handleClose}
						/>
						<Button
							label="Export"
							className="!min-w-[10rem]"
							color="Primary"
							onClick={() => setOpenExport(true)}
						/>
					</div>
				</>
			)}
			{openExport && (
				<ExportDataMyPeopleModal
					setOpen={setOpenExport}
					open={openExport}
					setOpenExportSucces={setOpenExportSucces}
					mutateExport={mutateExport}
					isReach
				/>
			)}
			{openExportSucces && (
				<ExportDataSuccesModal
					setOpen={setOpenExportSucces}
					open={openExportSucces}
					isReach
					errorMessage={exportErrorMessage}
				/>
			)}
		</div>
	)
}

export default ReachModal
